import Note from './note-container';

export default Note;
